export default "__VITE_ASSET__BEkXgG2L__"